const dateSort = (rowA, rowB, id) => {
  const a = rowA.values[id];
  const b = rowB.values[id];
  const a1 = new Date(a).getTime();
  const b1 = new Date(b).getTime();
  if (a1 < b1) return 1;
  if (a1 > b1) return -1;
  return 0;
};

const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;
  if (row[id] && row[id] !== undefined)
    return String(row[id].toLowerCase()).includes(filter.value.toLowerCase());
  return false;
};

const voucherStatusMapping = [
  'WIP',
  'Draft',
  'Submitted',
  'Approved',
  'Paid',
  'Voided',
  'Deleted',
];

module.exports = {
  dateSort,
  voucherStatusMapping,
  filterCaseInsensitive,
};
